module.exports = __webpack_public_path__ + "static/img/logo4.f666cf7b.png";